function cov_q7c7ybttx() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Jewel.tsx";
  var hash = "968ac965a1f4cf52050247eafb0d24a3aa40d238";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Jewel.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "968ac965a1f4cf52050247eafb0d24a3aa40d238"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_q7c7ybttx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_q7c7ybttx();
var Icon = (cov_q7c7ybttx().s[0]++, {
  name: 'jewel',
  svg: "<circle opacity=\"0.4\" cx=\"12\" cy=\"12\" r=\"8\" fill=\"currentColor\"/>\n  <circle cx=\"12\" cy=\"12\" r=\"4\" fill=\"currentColor\"/>"
});
export default Icon;